import { ApiResponse, fetcher } from './base-api';
import {
  DistrictEntity,
  ProvinceEntity,
  RegionEntity,
} from './types/region.type';

export const getRegionList = async (): Promise<ApiResponse<RegionEntity[]>> => {
  const response = await fetcher<ProvinceEntity[]>('/region');
  return {
    ...response,
    data: response.data.map(mapProvinceToRegion),
  };
};

// 변환 함수
function mapProvinceToRegion(province: ProvinceEntity): RegionEntity {
  return {
    label: province.province,
    value: province.province,
    count: province.count,
    districts: province.districts.map(mapDistrictToRegion),
  };
}
function mapDistrictToRegion(district: DistrictEntity): RegionEntity {
  return {
    label: district.district,
    value: district.district,
    count: district.count,
  };
}
